import { render, staticRenderFns } from "./LayoutDrawer.vue?vue&type=template&id=08665ae4&scoped=true&"
import script from "./LayoutDrawer.vue?vue&type=script&lang=ts&"
export * from "./LayoutDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutDrawer.vue?vue&type=style&index=0&id=08665ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08665ae4",
  null
  
)

export default component.exports